<div class="my-2">
        <a class="d-flex align-items-center justify-content-between recording" href="javascript:void(0)" (click)="startRecording()" *ngIf="recorderState == 'initial'" qid="rec-1">
                <div class="d-flex flex-column">
                        <p class="purple-heading recording-heading-1 mb-1">{{ 'TEACHER.ACTIVITYVIEW.START_RECORDING_MSG1' | translate }}</p>
                        <p class="purple-heading recording-heading-2 mb-0">{{ 'TEACHER.ACTIVITYVIEW.START_RECORDING_MSG2' | translate }}</p>
                </div>
                <div class="icon-wrapper purple-icon-wrapper  rounded-circle d-flex align-items-center justify-content-center">
                        <i class="nemo-font nemo-microphone" aria-hidden="true"></i>
                </div>
        </a>

        <a class="d-flex align-items-center justify-content-between recording" href="javascript:void(0)" (click)="playAudio()" *ngIf="recorderState == 'stopped'" qid="rec-2">
        <div class="d-flex flex-column">
                <p class="recording-heading-1 mb-1">{{ 'TEACHER.ACTIVITYVIEW.PLAY_RECORDING_MSG1' | translate }}</p>
                <p class="recording-heading-2 mb-0" [innerHTML]="'TEACHER.ACTIVITYVIEW.PLAY_RECORDING_MSG2' | translate:{elapsedTime: audioDuration}" *ngIf="audioDuration"></p>
        </div>
        <div class="icon-wrapper play-btn {{segment}} rounded-circle d-flex align-items-center justify-content-center">
                <i class="fa fa-play" aria-hidden="true"></i>
        </div>
        </a>

        <a class="d-flex align-items-center justify-content-between recording" href="javascript:void(0)" (click)="stopPlayingAudio()" *ngIf="recorderState == 'playing'" qid="rec-3">
                <div class="d-flex flex-column">
                        <p class="recording-heading-1 mb-1 red-heading">{{ 'TEACHER.ACTIVITYVIEW.STOP_PLAYING_MSG1' | translate }}</p>
                        <p class="recording-heading-2 mb-0 red-heading" *ngIf='audioDuration' [innerHTML]="'TEACHER.ACTIVITYVIEW.STOP_PLAYING_MSG2' | translate:{audioSeeker:audioSeeker,duration: audioDuration }"></p>
                </div>
                <div class="icon-wrapper outer-circle rounded-circle d-flex align-items-center justify-content-center">
                        <div class="inner-circle rounded-circle d-flex align-items-center justify-content-center">
                                <i class="fa fa-stop" aria-hidden="true"></i>
                        </div>
                </div>
        </a>
        <div class="d-flex align-items-center justify-content-between recording" *ngIf="recorderState == 'submitting' || recorderState == 'saving' || recorderState == 'processing'">
                <div class="d-flex flex-column">
                        <p class="recording-heading-1 mb-0" *ngIf="recorderState == 'submitting'">{{ 'TEACHER.ACTIVITYVIEW.SUBMITTING_MSG1' | translate }}</p>
                        <p class="recording-heading-1 mb-0" *ngIf="recorderState == 'saving'">{{ 'TEACHER.ACTIVITYVIEW.SAVING_MSG1' | translate }}</p>
                        <p class="recording-heading-1 mb-0" *ngIf="recorderState == 'processing'">{{ 'TEACHER.ACTIVITYVIEW.PROCESSING_MSG' | translate }}</p>
                </div>
                
                <div class="icon-wrapper rounded-circle d-flex align-items-center justify-content-center">
                        <div class="rounded-circle submitting-loader"></div>
                </div>
        </div>
        <a class="d-flex align-items-center justify-content-between recording recorder-bottom-element" [ngClass]="{'disabled' : recorderState == 'playing' || recorderState == 'submitting' || recorderState == 'saving' || recorderState == 'processing'}" href="javascript:void(0)" (click)="startRecording()" *ngIf="recorderState == 'stopped' || recorderState == 'playing' || recorderState == 'submitting' || recorderState == 'saving' || recorderState == 'processing'" qid="rec-4">
                <div class="d-flex flex-column">
                        <p class="purple-heading recording-heading-1 mb-1">{{ 'TEACHER.ACTIVITYVIEW.START_NEW_RECORDING_MSG1' | translate }}</p>
                        <p class="purple-heading recording-heading-2 mb-0">{{ 'TEACHER.ACTIVITYVIEW.START_NEW_RECORDING_MSG2' | translate }}</p>
                </div>
                <div class="icon-wrapper purple-icon-wrapper restart-icon-wrapper rounded-circle d-flex align-items-center justify-content-center">
                        <i class="nemo-font nemo-microphone" aria-hidden="true"></i>
                        <span class="restart rounded-circle d-flex align-items-center justify-content-center">
                                <i class="nemo-font nemo-refresh" aria-hidden="true"></i>
                        </span>
                </div>
        </a>


        <div class="d-flex align-items-center justify-content-between recording disabled" *ngIf="recorderState == 'recording'">
                <div class="d-flex flex-column">
                        <p class="recording-heading-1 mb-0">{{ 'TEACHER.ACTIVITYVIEW.RECORDING' | translate }}</p>
                        <!-- <p class="recording-heading-2 mb-0">Time: 00:01:39 / 00:01:56</p> -->
                </div>
                <div class="icon-wrapper grey-outer-circle rounded-circle d-flex align-items-center justify-content-center">
                        <div class="grey-inner-circle inner-circle rounded-circle d-flex align-items-center justify-content-center">
                                <i class="nemo-font nemo-audio-product" aria-hidden="true"></i>
                        </div>
                </div>
        </div>

        <a  #recordingElement class="d-flex align-items-center justify-content-between recording recorder-bottom-element" href="javascript:void(0)" (click)="stopRecording()" *ngIf="recorderState == 'recording'" qid="rec-5">
                <div class="d-flex flex-column">
                        <p class="recording-heading-1 mb-1 red-heading">{{ 'TEACHER.ACTIVITYVIEW.STOP_RECORDING_MSG1' | translate }}</p>
                        <span class="d-flex align-items-center">
                                <p class="recording-heading-2 mb-0 red-heading" [innerHTML]="'TEACHER.ACTIVITYVIEW.STOP_RECORDING_MSG2' | translate:{elapsedTime:elapsedTime} " *ngIf='elapsedTime'></p>
                                <p class="recording-time-left mb-0" *ngIf="elapsedLeftTime > 0">{{elapsedLeftTime}}{{ 'TEACHER.ACTIVITYVIEW.SEC_LEFT' | translate }}</p>
                        </span>
                </div>
                <div class="icon-wrapper outer-circle rounded-circle d-flex align-items-center justify-content-center">
                        <div class="inner-circle rounded-circle d-flex align-items-center justify-content-center">
                                <i class="fa fa-stop" aria-hidden="true"></i>
                        </div>
                </div>
        </a>
</div>

<button class="btn" [hidden]="true" data-toggle="modal" data-target="#recordingNotSupportedModal" #showRecordingErrorModalBtn>Show Error</button>
<div class="modal fade recordingNotSupported" tabindex="-1" role="dialog" id="recordingNotSupportedModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                        <div class="modal-body">
                                <p>
                                    {{ 'TEACHER.ACTIVITYVIEW.FORGIVE_US_TEXT_MSG1' | translate }}
                                </p>
                                <p style="font-weight: bold;">
                                    {{ 'TEACHER.ACTIVITYVIEW.RECORDING_NOT_POSSIBLE_MSG1' | translate }}
                                </p>
                                <p class="try-again" >
                                    {{ 'TEACHER.ACTIVITYVIEW.RECORDING_NOT_POSSIBLE_MSG2' | translate }}
                                </p>
                                                   
                        </div>
                        <div class="modal-footer">
                                <button class="btn" data-dismiss="modal" qid="rec-6">
                                    {{ 'TEACHER.ACTIVITYVIEW.OK' | translate }}
                                </button>
                        </div>
                </div>
        </div>
</div> 

